module.exports = __webpack_public_path__ + "img/logo4.f2a14059.png";